module.exports = __webpack_public_path__ + "img/user-activation.69a00128.jpg";